import { render, staticRenderFns } from "./FaqSubject.vue?vue&type=template&id=e2269300&scoped=true&"
import script from "./FaqSubject.vue?vue&type=script&lang=js&"
export * from "./FaqSubject.vue?vue&type=script&lang=js&"
import style0 from "./FaqSubject.vue?vue&type=style&index=0&id=e2269300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2269300",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
